import { render, staticRenderFns } from "./DigitalSolution.vue?vue&type=template&id=c78faff2&"
import script from "./DigitalSolution.vue?vue&type=script&lang=js&"
export * from "./DigitalSolution.vue?vue&type=script&lang=js&"
import style0 from "./DigitalSolution.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports